import { Address, JointPropertyRegime, MaritalStatus, Race } from '.'
import { AddressPayload } from './address'

export type PartnerBase = {
  name?: string
  rg?: string
  tax_id?: string
  phone?: string
  email?: string
  profession?: string
  specializations?: string[]
  nationality?: string
  marital_status?: MaritalStatus
  joint_property_regime?: JointPropertyRegime
  county_of_birth?: string
  crm?: string
  voter_registration?: string
  income_tax?: string
  pis?: string | null
  has_cnh?: boolean
  government_employee?: boolean
  contributor_inss?: boolean
  is_other_company_partner?: boolean
  is_main_partner?: boolean
  race?: Race
}

export type Partner = PartnerBase & {
  id: number
  key: string
  address?: Address
  partnership?: Partnership
}

export type PartnerPayload = PartnerBase & {
  address?: AddressPayload
  partnership?: Partial<Partnership>
}

export type PartnerResume = {
  id: number
  name: string
  tax_id: string
  key: string
  is_main: boolean
  is_admin: boolean
}

export type Partnership = {
  id: number
  partner_id: number
  company_id: number
  is_main: boolean
  is_admin: boolean
  pro_labore_amount?: number
  pro_labore_type?: 'fixed' | 'variable' | 'none'
  profit_share?: string
  company_share?: string
  inss_base_amount?: number
  inss_contribution_amount?: number
  second_cnpj_link?: string
  category_code?: string
  partner: PartnerResume
  admission_date?: string
  has_double_bond?: boolean
  dual_social_security_indicator?: string
}

export type ProfitSharePayload = {
  partner_id: number
  share_value: number
}

export const EDualSocialSecurityIndicator = {
  income_above_ceiling:
    'Remuneração do outro vínculo é igual ou superior ao teto (R$ 8.475,55)',
  income_below_ceiling: 'Remuneração do outro vínculo é inferior ao teto',
} as const

export type PartnerMonthlyWithdraw = {
  created_at: string
  updated_at: string
  id: number
  key: string
  partnership_id: number
  month: number
  year: number
  amount: string
}
